import { Button } from '@repo/ui/button';
import { cn } from '@repo/utils/cn';
import { CarouselApi } from '../../carousel';

type BannersIndicatorsProps = {
  api: CarouselApi;
  bannersLength: number;
  selectedBannerIndex: number;
  className?: string;
};

const BannersIndicators = ({ api, bannersLength, selectedBannerIndex, className }: BannersIndicatorsProps) => {
  return (
    <section className="my-4">
      <section
        className={cn(
          'flex w-full items-center justify-center space-x-2.5 rtl:space-x-reverse',
          {
            'md:hidden': bannersLength <= 2,
            'lg:hidden': bannersLength <= 3,
          },
          className
        )}
      >
        {[...Array(bannersLength)].map((_, i) => (
          <Button
            key={i}
            variant="blank"
            className="m-0 h-auto w-auto p-0"
            onClick={() => api?.scrollTo(i)}
          >
            <span
              className={cn('animate-in fade-in vt-surface-darker-bg h-1 w-2.5 rounded duration-200', {
                '!vt-atoms-btn-primary-bg w-8': i === selectedBannerIndex,
              })}
            />
          </Button>
        ))}
      </section>
    </section>
  );
};

export default BannersIndicators;
